/**
 * 组装商标标签保存请求中的标签名称。
 */
export function buildTrademarkTagNames(selectedTags: string[], inputValue: string): string[] {
  const trimmedInputValue = inputValue.trim();

  if (!trimmedInputValue || selectedTags.includes(trimmedInputValue)) {
    return selectedTags;
  }

  return [...selectedTags, trimmedInputValue];
}
